var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 9 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.985 19.935v-9.501h2.662L9 7.16H5.985l.004-1.639c0-.854.082-1.311 1.328-1.311H8.98V.935H6.318c-3.198 0-4.324 1.588-4.324 4.26V7.16H0v3.274h1.994v9.501h3.99Z",
    fill: "currentcolor",
    fillRule: "nonzero"
  })));
};

export default SvgFacebook;